/**
 * Audit-Log Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/done/audit-log.md
 *
 * Endpoint: GET /v1/admin/audit-logs (Plural!)
 * Response: { logs: [...], total }
 * Flat actor/user fields, `meta` statt `metadata`.
 */

const ACTIONS = [
  ['user.created',                         { source: 'operator-admin', accountType: 'business' }],
  ['user.suspended',                       { reasonCode: 'fraud', reasonNote: 'wiederholte Chargebacks' }],
  ['user.lifted_suspension',               {}],
  ['user.anonymized',                      { reason: 'DSGVO Art. 17 Request', jobId: 'job_9001' }],
  ['user.email_changed',                   { from: 'old@example.com', to: 'new@example.com' }],
  ['user.reverified_vat',                  { vatId: 'DE123456789', result: 'valid', reverseChargeEligible: true }],
  ['order.refunded',                       { refundAmount: 1999, currency: 'EUR', reason: 'service_unavailable' }],
  ['subscription.cancel',                  { immediate: false, atPeriodEnd: '2026-07-01', reason: 'customer_request' }],
  ['subscription.cancel_intent_confirmed', { intentId: 7001 }],
  ['api_key.created',                      { prefix: 'vlt_live_e5f6', scopes: ['saas.usage.write'] }],
  ['api_key.revoked',                      { reason: 'rotation' }],
  ['webhook.created',                      { url: 'https://valikey.app/webhooks/core' }],
  ['webhook.rotate_secret',                { webhookId: 12 }],
  ['app_setting.changed',                  { key: 'STRIPE_APPLICATION_FEE_BPS', from: '100', to: '150' }],
  ['policy.version_created',               { documentType: 'agb', version: '2026-v2' }],
  ['security.login',                       { mfa: true }],
  ['security.login_failed',                { reason: 'invalid_password' }],
];

const ACTORS = [
  { id: 4321, email: 'tobias@valitype.com' },
  { id: 4322, email: 'anneliese@valitype.com' },
  { id: null, email: null },                      // System
  { id: 4321, email: 'tobias@valitype.com' },
];

const TARGETS = [
  { id: 4711, email: 'customer1@example.com' },
  { id: 4712, email: 'customer2@example.com' },
  { id: 4713, email: 'customer3@example.com' },
  { id: null, email: null },
];

const UAS = [
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
  'Mozilla/5.0 (Windows NT 10.0; Win64; x64) Firefox/130.0',
  'curl/8.0.1',
  'orbit-cron/1.0',
];

export function auditLogsFixture({ action = '', userId = '', actorUserId = '', since, until } = {}) {
  const now = Date.now();
  const all = [];

  for (let i = 0; i < 60; i += 1) {
    const [act, meta] = ACTIONS[i % ACTIONS.length];
    const actor = ACTORS[i % ACTORS.length];
    const target = TARGETS[i % TARGETS.length];
    const createdAt = new Date(now - i * 17 * 60_000).toISOString();
    all.push({
      id: 9000 + i,
      action: act,
      actorUserId: actor.id,
      actorEmail: actor.email,
      userId: target.id,
      userEmail: target.email,
      meta,
      ip: `203.0.113.${(i * 13) % 256}`,
      userAgent: UAS[i % UAS.length],
      createdAt,
    });
  }

  const filtered = all.filter((e) => {
    if (action && e.action !== action) return false;
    if (userId && String(e.userId) !== String(userId)) return false;
    if (actorUserId && String(e.actorUserId) !== String(actorUserId)) return false;
    if (since && new Date(e.createdAt) < new Date(since)) return false;
    if (until && new Date(e.createdAt) >= new Date(until)) return false;
    return true;
  });

  return { logs: filtered, total: filtered.length };
}

// Whitelist für Action-Dropdown — Spec empfiehlt kuratierte Liste statt Backend-Endpoint
export const KNOWN_ACTIONS = ACTIONS.map(([a]) => a);
